module.exports = __webpack_public_path__ + "img/2-fa-enabled.9c8bfa36.svg";